import { formatDistanceToNow, format } from "date-fns";
import { parse } from "date-fns";

function timeAgo(dateTimeString: string) {
  try {
    const parsedDate = parse(
      dateTimeString,
      "dd-MMM-yyyy hh:mm:ss aa",
      new Date()
    );
    return formatDistanceToNow(parsedDate, { addSuffix: true });
  } catch (error) {
    console.error("Error parsing date:", error);
    return "Invalid Date";
  }
}
export default timeAgo;

export function getTimeOnly(dateTimeString: string) {
  try {
    const parsedDate = parse(
      dateTimeString,
      "dd-MMM-yyyy hh:mm:ss aa",
      new Date()
    );
    return format(parsedDate, "h:mm aa");
  } catch (error) {
    console.error("Error parsing date:", error);
    return "Invalid Date";
  }
}
